import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const tagState = (state: RootState) => state.tag;

const selectTags = createSelector(tagState, (state) => state.tags || []);

const selectTagsById = createSelector(selectTags, (tags) =>
  Object.fromEntries(tags.map((tag) => [tag._id, tag])),
);

const selectTagsLoading = createSelector(
  tagState,
  (state) => state.tagsLoading,
);

export const tagSliceSelectors = {
  selectTags,
  selectTagsById,
  selectTagsLoading,
};
